"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensTile = exports.LensTileDimensionsBySize = exports.LensTileSize = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* istanbul ignore file -- remove once added tests */
const web_sds_c_1 = require("@snapchat/web-sds-c");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const Placeholder_svg_1 = __importDefault(require("./icons/Placeholder.svg"));
const LensTile_module_css_1 = __importDefault(require("./LensTile.module.css"));
const BlurredIconTile_1 = require("../ImageTile/BlurredIconTile");
const ImageTile_1 = require("../ImageTile");
const LensNameWithLensSuffix_1 = require("../LensNameWithLensSuffix");
const StarIcon_1 = require("../../../icons/StarIcon");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
var LensTileSize;
(function (LensTileSize) {
    LensTileSize["small"] = "SmallLensTile";
    LensTileSize["medium"] = "MediumLensTile";
    LensTileSize["large"] = "LargeLensTile";
})(LensTileSize = exports.LensTileSize || (exports.LensTileSize = {}));
exports.LensTileDimensionsBySize = {
    [LensTileSize.small]: {
        height: "197px",
        width: "115px",
    },
    [LensTileSize.medium]: {
        height: "230px",
        width: "137px",
    },
    [LensTileSize.large]: { height: "460px", width: "274px" },
};
/**
 * LensTile: https://www.figma.com/file/o5nUWrWkZQen4HNUD0pDqE/Search-on-Web?node-id=117%3A8313
 */
function LensTile({ lens, onClick, size, useThinHeading, hideCreatorName, hideLensDescription, hideImageTileOverlay, openInNewTab, }) {
    const webClientId = (0, web_sc_cookies_1.useGetWebClientId)();
    // this is to allow consumer of this component to pass custom size options.
    const dimensions = Object.values(LensTileSize).includes(size)
        ? exports.LensTileDimensionsBySize[size]
        : size;
    const intl = (0, react_intl_1.useIntl)();
    const alt = `${lens.lensName} Lens and Filter by ${lens.creator.title} on Snapchat`;
    const [lensDeeplinkUrlWithWCID, setLensDeeplinkUrlWithWCID] = (0, react_1.useState)(lens.deeplinkUrl);
    const showTilePreview = Boolean(!lens.previewImageUrl && lens.iconUrl);
    const renderPlaceholderOverlay = () => ((0, jsx_runtime_1.jsx)("div", { className: LensTile_module_css_1.default.emptyTileMedia, children: (0, jsx_runtime_1.jsx)("span", { className: LensTile_module_css_1.default.placeHolder, children: (0, jsx_runtime_1.jsx)(Placeholder_svg_1.default, {}) }) }));
    const renderImageTileOverlay = () => {
        if (!lens.previewImageUrl && !lens.iconUrl) {
            return renderPlaceholderOverlay();
        }
        else {
            return ((0, jsx_runtime_1.jsx)("div", { className: LensTile_module_css_1.default.tileIconContainer, children: lens.iconUrl && ((0, jsx_runtime_1.jsx)("img", { className: LensTile_module_css_1.default.tileIcon, src: lens.iconUrl, alt: alt, "data-testid": "lens-tile-icon" })) }));
        }
    };
    const blurredTileAlt = intl.formatMessage({
        id: "G0CCzJ",
        description: "Snapchat Lens Icon",
        defaultMessage: "Snapchat Lens Icon for {lensName}",
    }, { lensName: lens.lensName });
    // update the link with WCID on the client side
    (0, react_1.useEffect)(() => {
        const paramSuffix = lens.deeplinkUrl.includes("?") ? "&" : "?";
        const lensDeeplinkUrlWithWCID = `${lens.deeplinkUrl}${paramSuffix}web_client_id=${webClientId || ""}`;
        setLensDeeplinkUrlWithWCID(lensDeeplinkUrlWithWCID);
    }, [lens.deeplinkUrl, webClientId]);
    return ((0, jsx_runtime_1.jsxs)("a", { href: lensDeeplinkUrlWithWCID, className: LensTile_module_css_1.default.link, onClick: onClick, "data-testid": "lensLink", style: { width: dimensions.width }, target: openInNewTab ? "_blank" : "", children: [(0, jsx_runtime_1.jsx)("div", { "data-testid": "lensImageTile", children: showTilePreview ? ((0, jsx_runtime_1.jsx)("div", { style: dimensions, children: (0, jsx_runtime_1.jsx)("span", { className: LensTile_module_css_1.default.blurredImageRadius, children: (0, jsx_runtime_1.jsx)(BlurredIconTile_1.BlurredIconTile, { iconUrl: lens.iconUrl, previewImageUrl: lens.iconUrl, size: "small", alt: blurredTileAlt }) }) })) : ((0, jsx_runtime_1.jsx)(ImageTile_1.ImageTile, { imageSrc: lens.previewImageUrl || lens.iconUrl, alt: lens.lensName, ...dimensions, children: !hideImageTileOverlay && renderImageTileOverlay() })) }), !hideLensDescription && ((0, jsx_runtime_1.jsxs)("div", { className: LensTile_module_css_1.default.description, "data-testid": "lensDescription", children: [(0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H6", emphasis: !useThinHeading, children: (0, jsx_runtime_1.jsx)("div", { className: LensTile_module_css_1.default.lensName, children: (0, jsx_runtime_1.jsx)(LensNameWithLensSuffix_1.LensNameWithLensSuffix, { lensName: lens.lensName }) }) }), !hideCreatorName && ((0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H6", children: (0, jsx_runtime_1.jsxs)("div", { className: LensTile_module_css_1.default.creatorName, children: [lens.creator.title, " ", (0, jsx_runtime_1.jsx)(StarIcon_1.StarIcon, { size: "MEDIUM" })] }) }))] }))] }));
}
exports.LensTile = LensTile;
//# sourceMappingURL=LensTile.js.map